import React from 'react';
import { compose, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import withLoader from '../app/withLoader';
import { withRouter } from 'react-router-dom';
import { withSnackbar } from 'notistack';
import { loadPrices, savePrices } from './_api';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import Button from '@material-ui/core/Button';
import { get } from 'lodash';

const styles = (theme) => ({
  root: {
    margin: 20,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
});

const items = [
  'LYZAKY',
  'LYZAKY<235',
  'LYZE',
  'LYZE_TOP',
  'LYZE<130',
  'HOLE_SJEZD',
  'BOTY_SNB',
  'SNB',
  'BOTY_BEH',
  'BEZKY',
  'HOLE_BEH',
  'PRILBY',
  'VAK',
  'TASKA',
  'BRYLE',
  'PATERAK',
  'NOSIC_KOULE',
];

const enhance = compose(
  withStyles(styles),
  withSnackbar,
  withLoader,
  withRouter,
  connect((state) => ({ formValues: getFormValues('pricesForm')(state) }), null),

  withHandlers({
    onSubmit:
      ({ toggleLoader, enqueueSnackbar }) =>
      async (values) => {
        toggleLoader();
        const resp = await savePrices(values);
        if (get(resp, 'success', false)) {
          enqueueSnackbar('Ceník byl uložen.', {
            variant: 'success',
          });
        } else {
          enqueueSnackbar('Ceník se nepodařilo uložit.', {
            variant: 'error',
          });
        }
        toggleLoader(false);
      },
  }),
  reduxForm({ form: 'pricesForm' }),
  lifecycle({
    async componentDidMount() {
      const { initialize, toggleLoader } = this.props;
      toggleLoader();
      const resp = await loadPrices();
      initialize(resp);
      toggleLoader(false);
    },
  })
);

export default enhance(({ classes, handleSubmit, formValues }) => (
  <div className={classes.root}>
    <Paper className={classes.paper}>
      <form className={classes.form} onSubmit={handleSubmit}>
        <table className="table-prices">
        <thead>
          <tr>
            <th>Název \ Dny</th>
            {Array.from(Array(14).keys()).map((item) => (
              <th key={item}>{item + 1}</th>
            ))}
            <th>Jistina</th>
            <th>Rez. poplatek</th>
          </tr>
          </thead>
          <tbody>
            {items.map((name) => (
              <tr key={name} className="price-row">
                <td>{name}</td>
                {Array.from(Array(14).keys()).map((item) => (
                  <td>
                    <Field
                      name={`${name}.d${item + 1}`}
                      type="number"
                      component={TextField}
                      label={``}
                    />
                  </td>
                ))}
                <td>
                  <Field
                    name={`${name}.principal`}
                    type="number"
                    component={TextField}
                    label={``}
                  />
                </td>
                <td>
                  <Field
                    name={`${name}.reservationFee`}
                    type="number"
                    component={TextField}
                    label={``}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ marginTop: 20 }}>
          <Button type="submit" variant="contained" color="primary" className={classes.submit}>
            Uložit
          </Button>
        </div>
      </form>
    </Paper>
  </div>
));



// WEBPACK FOOTER //
// ./src/modules/prices/index.js